import React, {useState} from 'react';
import {Formik, Field, FormikProps, FormikHelpers} from 'formik';

import mappings from '@mappings';
import utils from '@utils';
import {Form, Button, Table, Pagination} from '@components';
import {makeColumns} from './Columns';
import {Props} from './types';
import * as hooks from './hooks';
import * as handlers from './handlers';
import validations from '@validations';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [loading, setLoading] = useState(true);
  const [isPaging, setIsPaging] = useState(false);

  const initialValues = {
    disaster: null,
    prefecture: null,
    fromSentDatetime: null,
    toSentDatetime: null,
  };

  hooks.useMount(props, {setLoading});

  return (
    <div className="a__notices">
      <div className="b__title">災害通知履歴</div>

      <Formik
        initialValues={initialValues}
        onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
          handlers.searchNotifications(values, formikHelpers, props, setLoading)
        }
        validate={validations.notifications.main}
      >
        {(formProps: FormikProps<any>) => {
          return (
            <>
              <div className="w__search-field">
                <div className="w__search-contents">
                  <div className="w__field calendar">
                    <Form.Label text="安否確認送信日時" />
                    <div className="w__calendar">
                      <div className="w__search-form date-picker">
                        <Field
                          component={Form.DatePicker}
                          name="fromSentDatetime"
                          placeholder="選択してください"
                          color="white"
                        />
                      </div>
                      <div className="wave">〜</div>
                      <div className="w__search-form">
                        <Field
                          component={Form.DatePicker}
                          name="toSentDatetime"
                          placeholder="選択してください"
                          color="white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w__field">
                    <Form.Label text="災害" />
                    <div className="w__search-form">
                      <Field
                        component={Form.Dropdown}
                        name="disasterType"
                        placeholder="選択してください"
                        color="white"
                        options={utils.mappings.createSelections(
                          mappings.disasters,
                          true
                        )}
                      />
                    </div>
                  </div>
                  <div className="w__field">
                    <Form.Label text="地域" />
                    <div className="w__search-form">
                      <Field
                        component={Form.Dropdown}
                        name="prefecture"
                        placeholder="選択してください"
                        color="white"
                        options={utils.mappings.createSelections(
                          mappings.prefectures,
                          true
                        )}
                      />
                    </div>
                  </div>
                  <div className="w__search-button">
                    <Button.Normal
                      large
                      text="検索する"
                      color="yellow"
                      rounded
                      disabled={formProps.isSubmitting || loading}
                      loading={formProps.isSubmitting}
                      onClick={() => {
                        formProps.handleSubmit();
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="b__count">
                合計&nbsp;
                <span className="count">
                  {Number(
                    props.notifications.pagination.totalCount
                  ).toLocaleString()}
                </span>
                &nbsp;件
              </div>
              <div className="b__table">
                <Table.Main
                  columns={makeColumns(props, setLoading)}
                  data={props.notifications.pagination.data.active}
                  loading={formProps.isSubmitting || loading}
                  emptyMessage="災害通知履歴がありません"
                />
                <Pagination
                  totalCount={props.notifications.pagination.totalCount}
                  current={props.notifications.pagination.current}
                  updateCurrent={(current: number) => {
                    handlers.updateCurrent(props, current, setIsPaging);
                  }}
                  disabled={isPaging || loading}
                />
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default Main;
